import axios from "axios";
import { useEffect, useState } from "react";
import { getRules } from "../api/rulesApi";
import type { RuleBlock } from "../types";

// Loads the rules and reloads them whenever the language changes
export const useRules = (language: string) => {
    const [rules, setRules] = useState<RuleBlock[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();

        setLoading(true);
        getRules(language, controller.signal)
            .then(setRules)
            .catch((error) => {
                // A cancelled request is expected, not an error
                if (!axios.isCancel(error)) {
                    console.error("Failed to load rules:", error);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });

        // Cancel the in-flight request if the language changes or the page unmounts
        return () => controller.abort();
    }, [language]);

    return { rules, loading };
};